import * as yup from 'yup'

import constants from 'constants/index'

const schema = () =>
  yup.object().shape({
    reportSelected: yup.string().required(),
    bannerId: yup
      .object()
      .nullable()
      .when('reportSelected', {
        is: constants.cookies.reports.REPORT_TYPES.BY_BANNER,
        then: yup
          .object()
          .nullable()
          .required('Selecione um banner')
          .typeError('Selecione um banner'),
        otherwise: yup.object().nullable(),
      }),
    consentType: yup.string().nullable(),
    startDate: yup.date().nullable(),
    endDate: yup
      .date()
      .nullable()
      .when('startDate', {
        is: (startDate) => !!startDate,
        then: yup
          .date()
          .nullable()
          .min(
            yup.ref('startDate'),
            'A data final não pode ser anterior à data inicial',
          ),
      }),
  })

export default schema
